import { Site } from '@envato/foundation-types'
import noIndexAllowList from './noIndexAllowList'
import defaultConfig from './defaults'

export default {
  name: 'CodeCanyon',
  abbreviation: 'CC',
  domain: 'codecanyon.net',
  google_analytics_id: 'UA-11834194-12',
  google_remarketing_label: 'bdtlCM3-uQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. eCommerce plugin',
  filterOrder: [
    'category',
    'tags',
    'price',
    'discounted-only',
    'software-version',
    'compatible-with',
    'sales',
    'rating',
    'date-added',
    'date-updated'
  ],
  features: {},
  noIndex: noIndexAllowList({
    site: Site.codecanyon,
    routes: defaultConfig.noIndex.routes,
    params: defaultConfig.noIndex.params
  }),
  forced_features: {
    /**
     * @description Adjustments for "homePageCopyUpdates" experiment, sets winning features for some sites
     * @author Pawel
     * @expires when "homePageCopyUpdates" experiment is over
     */
    ogCopyVerbatim: false,
    combinedCopyNoDollars: true,
    combinedCopyWithDollars: false
  },
  CSATFeedbackURL: 'https://www.getfeedback.com/r/j8tDJzCd'
}
